module.exports = __webpack_public_path__ + "videos/mts-products-chats-distribution-groups.2e5948c.mp4";